import {
    TwitterShareButton,
    XIcon,
} from "react-share";
import styles from './shareButton.module.css';
import { useState } from "react";

export function ShareButton({ correctCount, questionsLength, finalTime }) {
    const shareUrl = "https://www.qodo.ai/bugechasegame/";
    // const title = `I just played @QodoAI bug chase. Now its your turn to race the Qodo Reviewer.`;

    const title = `I just played @QodoAI Bug Chase game🐞
How many bugs can you find in 60 seconds?
Try this fun challenge 👉`

    // const title = 'Played Qodo’s Bug Chase. Your turn to race the AI code reviewer.';
    // const title = `🎮 I scored ${correctCount}/${questionsLength} in the code game! ⏱ Time: ${finalTime}s`;
    const [copied, setCopied] = useState(false);

    const copyLink = async () => {
        await navigator.clipboard.writeText(shareUrl);
        setCopied(true);
        setTimeout(() => setCopied(false), 1500);
    };

    // I need to tag https://x.com/QodoAI
    return (
        <div className={styles.shareContainer}>
            <div className={styles.shareBtn}>
                <TwitterShareButton
                    url={shareUrl}
                    title={title}
                >
                    Share on
                    <XIcon size={50} round />
                </TwitterShareButton>
            </div>

            {/* <div className={styles.shareBtn}>
                <button
                    type="button"
                    onClick={copyLink}
                    className={styles.copyBtn}
                    aria-label="Copy link"
                >
                    {copied ? "✅" : "🔗"}
                </button>
            </div> */}

        </div>
    );
}
